"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _form = require("@jsluna/form");

var _button = require("@jsluna/button");

var _grid = require("@jsluna/grid");

var _progress = require("@jsluna/progress");

var _InfoModal = _interopRequireDefault(require("./Modal/InfoModal"));

var _AddressListModal = _interopRequireDefault(require("./Modal/AddressListModal"));

var _apiConfig = _interopRequireDefault(require("../../api/apiConfig"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable prettier/prettier */


var AddressSearchBox = function AddressSearchBox(props) {
  var setSelectedAddress = props.setSelectedAddress,
      showNoAddressError = props.showNoAddressError,
      clearNoAddressError = props.clearNoAddressError;

  var _useState = (0, _react.useState)(),
      addressDetails = _useState[0],
      setAddressDetails = _useState[1];

  var _useState2 = (0, _react.useState)(),
      postCode = _useState2[0],
      setPostCode = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isModalOpen = _useState3[0],
      setIsModalOpen = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      isListModalOpen = _useState4[0],
      setIsListModalOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      isPostCodeValid = _useState5[0],
      setIsPostCodeValid = _useState5[1];

  var _useState6 = (0, _react.useState)(),
      isPostCodeEmpty = _useState6[0],
      setIsPostCodeEmpty = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      selectedAddressIndex = _useState7[0],
      setSelectedAddressIndex = _useState7[1];

  var _useState8 = (0, _react.useState)(''),
      selectAddressError = _useState8[0],
      setSelectAddressError = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      isLoading = _useState9[0],
      setIsLoading = _useState9[1];

  var mounted = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!mounted.current) {
      // componentDidMount
      document.querySelector('[for="address-not-given-check-box"]').className += ' c-checkbox-label';
    } else {// componentDidUpdate
    }
  }, []);

  var handleInfoModalClose = function handleInfoModalClose() {
    setIsModalOpen(false);
  };

  var handleListModalClose = function handleListModalClose() {
    setIsListModalOpen(false);
    setSelectAddressError('');
  };

  var isValidPostCode = function isValidPostCode() {
    // eslint-disable-next-line max-len
    var regEx = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;
    return regEx.test(postCode);
  };

  var displayErrorMessage = function displayErrorMessage() {
    if (!isPostCodeValid) {
      return 'Please enter a valid postcode';
    }

    if (isPostCodeEmpty) {
      return 'Please enter a postcode';
    }

    if (showNoAddressError) {
      if (!postCode) {
        return 'Please enter a postcode';
      }

      return 'Please select the \'Find address\' button';
    }

    return '';
  };

  var handleSelectAddressClick = function handleSelectAddressClick() {
    if (!selectedAddressIndex) {
      setSelectAddressError('Please select an address');
    } else {
      setSelectAddressError('');
      setSelectedAddressIndex(selectedAddressIndex);
      setSelectedAddress(addressDetails[selectedAddressIndex]);
      setSelectedAddressIndex('');
      handleListModalClose();
    }
  };

  var handleSelectAddressChange = function handleSelectAddressChange(event) {
    setSelectedAddressIndex(event);
    setSelectAddressError('');
  };

  var onPostcodeInputChange = function onPostcodeInputChange(event) {
    setPostCode(event.target.value.toUpperCase());
    setIsPostCodeEmpty(false);
    setIsPostCodeValid(true);
    clearNoAddressError(false);
  };

  var getMatchingAddress = function getMatchingAddress() {
    setIsLoading(true);
    clearNoAddressError(false);

    if (!postCode) {
      setIsPostCodeEmpty(true);
      setIsLoading(false);
    } else if (!isValidPostCode()) {
      setIsPostCodeValid(false);
      setIsLoading(false);
    } else {
      var result = fetch(_apiConfig.default.getAddressFinderApiUrl() + "/GbGroupAddressFinder?postCode=" + postCode);
      result.then(function (response) {
        return response.json();
      }).then(function (data) {
        setAddressDetails(data);
        setIsModalOpen(true);
        setIsListModalOpen(true);
        setIsLoading(false);
      }).catch(function (error) {
        console.log(error);
        setIsLoading(false);
      });
    }
  };

  var getAddressList = function getAddressList() {
    return addressDetails && addressDetails.map(function (x) {
      return x.formattedAddress;
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_progress.ProgressIndicator, {
    className: "c-overlay-position",
    loading: isLoading,
    page: true
  }, /*#__PURE__*/_react.default.createElement(_progress.ProgressSpinner, null)), addressDetails && addressDetails.length === 0 ? /*#__PURE__*/_react.default.createElement(_InfoModal.default, {
    isOpen: isModalOpen,
    headerText: "No addresses were found that match the postcode " + postCode + ".",
    bodyText: "Please check and try again or enter the address manually.",
    buttonText: "OK",
    handleClose: function handleClose() {
      return handleInfoModalClose();
    }
  }) : /*#__PURE__*/_react.default.createElement(_AddressListModal.default, {
    isOpen: isListModalOpen,
    headerText: "Select an address",
    bodyText: "",
    addressList: getAddressList(),
    buttonText: "Select address",
    handleClose: function handleClose() {
      return handleListModalClose();
    },
    onChange: function onChange(e) {
      return handleSelectAddressChange(e);
    },
    errorValidation: selectAddressError,
    onSelectAddressBtn: function onSelectAddressBtn() {
      return handleSelectAddressClick();
    }
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      xs: '1/2',
      md: '1/3',
      lg: '1/4',
      xl: '1/3'
    }
  }, /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    className: "ln-u-margin-bottom*2",
    placeholder: "e.g. M16 0RA",
    label: "Enter a postcode",
    onChange: function onChange(e) {
      return onPostcodeInputChange(e);
    },
    error: displayErrorMessage()
  }), /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    className: "ln-u-margin-bottom*3",
    fullWidth: true,
    onClick: function onClick() {
      return getMatchingAddress();
    }
  }, "Find address"))));
};

AddressSearchBox.propTypes = {
  setSelectedAddress: _propTypes.PropTypes.func.isRequired,
  showNoAddressError: _propTypes.PropTypes.bool.isRequired,
  clearNoAddressError: _propTypes.PropTypes.func.isRequired
};
var _default = AddressSearchBox;
exports.default = _default;